import { Time } from "../../utils/time";

export interface StoreState {
  allStores: Store[];
  favoriteStores: Store[] | null;
  prefectures: Record<string, string[]>;
}

export interface Store {
  id: number;
  name: string;
  storeCode: string;
  service: string;
  phoneNumber: string;
  address: string;
  area: Area;
  location: Location;
  prefecture: string;
  city: string;
  isFavorite: boolean;
  isPaymentAvailable: boolean;
  shortestTimeUntilPickup: number;
  businessHourOpen: Time;
  businessHourClose: Time;
  businessHourText: string;
  is24Hours: boolean;
  isOvernight: boolean;
  isOrderStopped: boolean;
}

type Area = {
  id: number;
  name: string;
};

type Location = {
  altitude: number;
  latitude: number;
  longitude: number;
};

export enum StoreSearchType {
  Text = "text",
  Address = "address",
  MyStore = "mystore",
  StoreCode = "store_code",
}
